<template>
    <div>
        <template>
            <div style="font-size:16px; background-color: #005B5B;">
                <h5 class="text-white text-center"> {{ service_name_check === 2 ? $t('externalUser.beneficiary_account_x') : $t('globalTrans.beneficiary_account') }}
                </h5>
            </div>
        </template>
        <b-row class="mt-4">
            <b-col sm="12" lg="6">
                <ValidationProvider name="Beneficiary Account Type" vid="beneficiary_account_type" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="beneficiary_account_type"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('globalTrans.beneficiary_account_type')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="beneficiary.account_type"
                            :options="beneficiaryAccountType"
                            @change="dataReturn"
                            id="beneficiary_account_type"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="beneficiary_account_type_help beneficiary_account_type_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text id="beneficiary_account_type_help" class="sr-only">
                        Please select the beneficiary's account type from the list.
                        </b-form-text>
                        <!-- Error message using div -->
                        <div
                            id="beneficiary_account_type_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                <ValidationProvider name="Account Type" vid="bank_account_type" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="bank_account_type"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('globalTrans.account_type')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="beneficiary.bank_account_type"
                            :options="bankAccountType"
                            @change="dataReturn"
                            id="bank_account_type"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="bank_account_type_help bank_account_type_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text (English) -->
                        <b-form-text id="bank_account_type_help" class="sr-only">
                        Please select the account type for the bank account.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="bank_account_type_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" lg="12" v-if="beneficiary.account_type===1">
                <b-row v-if="service_name_check === 2">
                        <b-col  sm="12" lg="6">
                            <ValidationProvider name="Bank name" vid="bank_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="bank_id"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{$t('externalUser.bank_name')}}
                                        <span class="text-danger" aria-hidden="true">*</span>
                                        <span class="sr-only">required</span>
                                    </template>
                                    <v-select name="Bank"
                                        v-model="beneficiary.bank_id"
                                        label="text"
                                        :reduce="item => item.value"
                                        :options= bankList
                                        :placeholder="$t('globalTrans.select')"
                                        aria-required="true"
                                        :aria-invalid="errors.length ? 'true' : 'false'"
                                        aria-describedby="bank_id_help bank_id_error"
                                    />
                                   <!-- Help text (screen-reader only) -->
                                    <b-form-text id="bank_id_help" class="sr-only">
                                    Please select the bank name from the list.
                                    </b-form-text>

                                    <!-- Error message -->
                                    <div
                                    id="bank_id_error"
                                    class="invalid-feedback d-block"
                                    role="alert"
                                    aria-live="assertive"
                                    >
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col  sm="12" lg="6">
                            <ValidationProvider name="District name" vid="district_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="district_id"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{ $t('org_pro_district.district') }}
                                        <span class="text-danger" aria-hidden="true">*</span>
                                        <span class="sr-only">required</span>
                                    </template>
                                    <v-select name="District"
                                        v-model="beneficiary.branch_district_id"
                                        label="text"
                                        :reduce="item => item.value"
                                        :options="districtList"
                                        :placeholder="$t('globalTrans.select')"
                                        aria-required="true"
                                        :aria-invalid="errors.length ? 'true' : 'false'"
                                        aria-describedby="district_id_help district_id_error"
                                    />
                                    <!-- Help text (screen-reader only) -->
                                    <b-form-text id="district_id_help" class="sr-only">
                                    Please select the district name from the list.
                                    </b-form-text>

                                    <!-- Error message -->
                                    <div
                                    id="district_id_error"
                                    class="invalid-feedback d-block"
                                    role="alert"
                                    aria-live="assertive"
                                    >
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col  sm="12" lg="6" v-if="beneficiary.branch_district_id > 0">
                            <ValidationProvider name="Branch" vid="branch_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="branch_id"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{ $t('org_pro.branch') }}
                                        <span class="text-danger" aria-hidden="true">*</span>
                                        <span class="sr-only">required</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="beneficiary.branch_id"
                                        :options="branchList"
                                        id="branch_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        aria-required="true"
                                        :aria-invalid="errors.length ? 'true' : 'false'"
                                        aria-describedby="branch_id_help branch_id_error"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option disabled :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <!-- Help text (screen-reader only) -->
                                    <b-form-text id="branch_id_help" class="sr-only">
                                    Please select the branch from the list.
                                    </b-form-text>

                                    <!-- Error message -->
                                    <div
                                    id="branch_id_error"
                                    class="invalid-feedback d-block"
                                    role="alert"
                                    aria-live="assertive"
                                    >
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                </b-row>
                <b-row v-else>
                    <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                        <ValidationProvider name="Bank Name (En)" vid="bank_name" rules="required|max:100">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="bank_name"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('globalTrans.bank_name_en')}}
                                    <span class="text-danger" aria-hidden="true">*</span>
                                    <span class="sr-only">required</span>
                                </template>
                                <b-form-input
                                    class="form-control"
                                    v-model="beneficiary.bank_name"
                                    @keyup="dataReturn"
                                    id="bank_name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    aria-required="true"
                                    :aria-invalid="errors.length ? 'true' : 'false'"
                                    aria-describedby="bank_name_help bank_name_error"
                                ></b-form-input>
                                <!-- Help text (screen-reader only) -->
                                <b-form-text
                                id="bank_name_help"
                                class="sr-only"
                                >
                                Enter the bank name in English. Maximum 100 characters.
                                </b-form-text>

                                <!-- Error message -->
                                <div
                                id="bank_name_error"
                                class="invalid-feedback d-block"
                                role="alert"
                                aria-live="assertive"
                                >
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                        <ValidationProvider name="Bank Name (Bn)" vid="bank_name_bn" rules="required|max:100">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="bank_name_bn"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('globalTrans.bank_name_bn')}}
                                    <span class="text-danger" aria-hidden="true">*</span>
                                    <span class="sr-only">required</span>
                                </template>
                                <b-form-input
                                    class="form-control"
                                    v-model="beneficiary.bank_name_bn"
                                    @keyup="dataReturn"
                                    id="bank_name_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    aria-required="true"
                                    :aria-invalid="errors.length ? 'true' : 'false'"
                                    aria-describedby="bank_name_bn_help bank_name_bn_error"
                                ></b-form-input>
                                <!-- Help text (screen-reader only) -->
                                <b-form-text id="bank_name_bn_help" class="sr-only">
                                Enter the bank name in Bengali. Maximum 100 characters.
                                </b-form-text>

                                <!-- Error message -->
                                <div
                                id="bank_name_bn_error"
                                class="invalid-feedback d-block"
                                role="alert"
                                aria-live="assertive"
                                >
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                        <ValidationProvider name="Branch Name (En)" vid="branch_name" rules="required|max:100">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="branch_name"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('globalTrans.branch_name_en')}}
                                    <span class="text-danger" aria-hidden="true">*</span>
                                    <span class="sr-only">required</span>
                                </template>
                                <b-form-input
                                    class="form-control"
                                    v-model="beneficiary.branch_name"
                                    @keyup="dataReturn"
                                    id="branch_name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    aria-required="true"
                                    :aria-invalid="errors.length ? 'true' : 'false'"
                                    aria-describedby="branch_name_help branch_name_error"
                                ></b-form-input>
                                <!-- Help text (screen-reader only) -->
                                <b-form-text id="branch_name_help" class="sr-only">
                                Enter the branch name in English. Maximum 100 characters.
                                </b-form-text>

                                <!-- Error message -->
                                <div
                                id="branch_name_error"
                                class="invalid-feedback d-block"
                                role="alert"
                                aria-live="assertive"
                                >
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                        <ValidationProvider name="Branch Name (Bn)" vid="branch_name_bn" rules="required|max:100">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="branch_name_bn"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('globalTrans.branch_name_bn')}}
                                    <span class="text-danger" aria-hidden="true">*</span>
                                    <span class="sr-only">required</span>
                                </template>
                                <b-form-input
                                    class="form-control"
                                    v-model="beneficiary.branch_name_bn"
                                    @keyup="dataReturn"
                                    id="branch_name_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    aria-required="true"
                                    :aria-invalid="errors.length ? 'true' : 'false'"
                                    aria-describedby="branch_name_bn_help branch_name_bn_error"
                                ></b-form-input>
                                <!-- Help text (screen-reader only) -->
                                <b-form-text id="branch_name_bn_help" class="sr-only">
                                Enter the branch name in Bengali. Maximum 100 characters.
                                </b-form-text>

                                <!-- Error message -->
                                <div
                                id="branch_name_bn_error"
                                class="invalid-feedback d-block"
                                role="alert"
                                aria-live="assertive"
                                >
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                <ValidationProvider name="Account Name (En)" vid="account_name_en" rules="required|max:100">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="account_name_en"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('globalTrans.account_name_en')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-input
                            class="form-control"
                            v-model="beneficiary.account_name"
                            @keyup="dataReturn"
                            id="account_name_en"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="account_name_en_help account_name_en_error"
                        ></b-form-input>
                        <!-- Help text (screen-reader only) -->
                        <b-form-text id="account_name_en_help" class="sr-only">
                        Enter the account name in English. Maximum 100 characters.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="account_name_en_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                <ValidationProvider name="Account Name (Bn)" vid="account_name_bn" rules="required|max:100">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="account_name_bn"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('globalTrans.account_name_bn')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-input
                            class="form-control"
                            v-model="beneficiary.account_name_bn"
                            @keyup="dataReturn"
                            id="account_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="account_name_bn_help account_name_bn_error"
                        ></b-form-input>
                        <!-- Help text (screen-reader only) -->
                        <b-form-text id="account_name_bn_help" class="sr-only">
                        Enter the account name in Bengali. Maximum 100 characters.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="account_name_bn_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" lg="6" v-if="beneficiary.account_type===1">
                <ValidationProvider name="Account No" vid="account_no" rules="required|max:24">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="account_no"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('globalTrans.account_no') + ' (' + $t('externalUser.en') + ')' }}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-input
                            type="number"
                            class="form-control"
                            v-model="beneficiary.account_no"
                            @keyup="dataReturn"
                            id="account_no"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="account_no_help account_no_error"
                        ></b-form-input>
                        <!-- Help text (screen-reader only) -->
                        <b-form-text id="account_no_help" class="sr-only">
                        Enter your account number in English. Maximum 24 digits.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="account_no_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
                <b-col sm="12" lg="6" v-if="beneficiary.account_type===2">
                    <ValidationProvider name="MFS Service" vid="mfs_service" rules="required|min_value:1">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="mfs_service"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('globalTrans.mfs_service')}}
                                <span class="text-danger" aria-hidden="true">*</span>
                                <span class="sr-only">required</span>
                            </template>
                            <b-form-select
                                plain
                                v-model="beneficiary.mfs_service"
                                :options="mfsService"
                                @change="dataReturn"
                                id="mfs_service"
                                :state="errors[0] ? false : (valid ? true : null)"
                                aria-required="true"
                                :aria-invalid="errors.length ? 'true' : 'false'"
                                aria-describedby="mfs_service_help mfs_service_error"
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                            </b-form-select>
                            <!-- Help text (screen-reader only) -->
                            <b-form-text id="mfs_service_help" class="sr-only">
                            Please select your Mobile Financial Service provider.
                            </b-form-text>

                            <!-- Error message -->
                            <div
                            id="mfs_service_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                            >
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="6" v-if="beneficiary.account_type===2">
                    <ValidationProvider name="Account Name (En)" vid="account_name_en" rules="required|max:100">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="account_name_en"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('globalTrans.account_name_en')}}
                                <span class="text-danger" aria-hidden="true">*</span>
                                <span class="sr-only">required</span>
                            </template>
                            <b-form-input
                                class="form-control"
                                v-model="beneficiary.mfs_account_name"
                                @keyup="dataReturn"
                                id="account_name_en"
                                :state="errors[0] ? false : (valid ? true : null)"
                                aria-required="true"
                                :aria-invalid="errors.length ? 'true' : 'false'"
                                aria-describedby="account_name_en_help account_name_en_error"
                            ></b-form-input>
                            <!-- Help text (screen-reader only) -->
                            <b-form-text id="account_name_en_help" class="sr-only">
                            Enter your Mobile Financial Service account name in English. Maximum 100 characters.
                            </b-form-text>

                            <!-- Error message -->
                            <div
                            id="account_name_en_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                            >
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="6" v-if="beneficiary.account_type===2">
                    <ValidationProvider name="Account Name (Bn)" vid="account_name_bn" rules="required|max:100">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="account_name_bn"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('globalTrans.account_name_bn')}}
                                <span class="text-danger" aria-hidden="true">*</span>
                                <span class="sr-only">required</span>
                            </template>
                            <b-form-input
                                class="form-control"
                                v-model="beneficiary.mfs_account_name_bn"
                                @keyup="dataReturn"
                                id="account_name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                aria-required="true"
                                :aria-invalid="errors.length ? 'true' : 'false'"
                                aria-describedby="account_name_bn_help account_name_bn_error"
                            ></b-form-input>
                            <!-- Help text (screen-reader only) -->
                            <b-form-text id="account_name_bn_help" class="sr-only">
                            Enter your Mobile Financial Service account name in Bengali. Maximum 100 characters.
                            </b-form-text>

                            <!-- Error message -->
                            <div
                            id="account_name_bn_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                            >
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="6" v-if="beneficiary.account_type===2">
                    <ValidationProvider name="Account No" vid="account_no" rules="required|max:24">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="account_no"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('globalTrans.account_no')}}
                                <span class="text-danger" aria-hidden="true">*</span>
                                <span class="sr-only">required</span>
                            </template>
                            <b-form-input
                                class="form-control"
                                v-model="beneficiary.mfs_account_no"
                                @keyup="dataReturn"
                                id="account_no"
                                :state="errors[0] ? false : (valid ? true : null)"
                                aria-required="true"
                                :aria-invalid="errors.length ? 'true' : 'false'"
                                aria-describedby="account_no_help account_no_error"
                            ></b-form-input>
                            <!-- Help text (screen-reader only) -->
                            <b-form-text id="account_no_help" class="sr-only">
                            Enter your Mobile Financial Service account number. Maximum 24 digits.
                            </b-form-text>

                            <!-- Error message -->
                            <div
                            id="account_no_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                            >
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="6" v-if="service_name_check === 5 && beneficiary.account_type===1">
                    <ValidationProvider name="Routing No" vid="routing_no" rules="required|max:100">
                        <b-form-group
                            class="row"
                            label-cols-sm="5"
                            label-for="routing_no"
                            slot-scope="{ valid, errors }"
                        >
                            <template v-slot:label>
                                {{$t('externalUser.routing_no')}}
                                <span class="text-danger" aria-hidden="true">*</span>
                                <span class="sr-only">required</span>
                            </template>
                            <b-form-input
                                class="form-control"
                                v-model="beneficiary.routing_no"
                                id="routing_no"
                                :state="errors[0] ? false : (valid ? true : null)"
                                aria-required="true"
                                :aria-invalid="errors.length ? 'true' : 'false'"
                                aria-describedby="routing_no_help routing_no_error"
                            ></b-form-input>
                            <!-- Help text -->
                            <b-form-text
                            id="routing_no_help"
                            class="sr-only"
                            >
                            {{ $t('externalUser.routing_no_help') }}
                            </b-form-text>

                            <!-- Error message (always in DOM) -->
                            <div
                            id="routing_no_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                            >
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="6" v-if="service_name_check === 5 && beneficiary.account_type===1">
                    <ValidationProvider name="Attachment" vid="upload_attachment7" ref="attachmentProvider">
                            <b-form-group
                                class="row"
                                label-cols-sm="5"
                                label-for="upload_attachment7"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{ $t('externalUser.cheque_book_attachment') }}
                                    <span class="text-danger" aria-hidden="true">*</span>
                                    <span class="sr-only">required</span>
                                </template>
                                <b-form-file
                                    id="upload_attachment7"
                                    accept=".png, .jpg, .jpeg, .svg, .pdf, .doc, .docx, .tex, .txt, .rtf"
                                    v-model="uploadAttachment7"
                                    v-on:change="onAttachmentChange7"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    aria-required="true"
                                    :aria-invalid="errors.length ? 'true' : 'false'"
                                    aria-describedby="upload_attachment7_help upload_attachment7_error"
                                ></b-form-file>
                                <!-- Help text -->
                                <b-form-text
                                id="upload_attachment7_help"
                                class="sr-only"
                                >
                                Upload a cheque book attachment (accepted formats: PDF, image, or document files).
                                </b-form-text>

                                <!-- Error message (always in DOM) -->
                                <div
                                id="upload_attachment7_error"
                                class="invalid-feedback d-block"
                                role="alert"
                                aria-live="assertive"
                                >
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                </b-col>
        </b-row>
    </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import RestApi, { commonServiceBaseUrl } from '@/config/api_config'

export default {
    props: ['data', 'service_name_check'],
    components: {
        ValidationProvider
    },
    data () {
        return {
            beneficiary: {
                account_type: 0,
                bank_id: 0,
                branch_id: 0,
                branch_district_id: 0,
                bank_name: '',
                bank_name_bn: '',
                branch_name: '',
                branch_name_bn: '',
                bank_account_type: '',
                account_name: '',
                account_name_bn: '',
                account_no: '',
                mfs_service: '',
                mfs_account_name: '',
                mfs_account_name_bn: '',
                mfs_account_no: '',
                attachment7: ''
            },
            bankList: [],
            branchList: [],
            uploadAttachment7: [],
            initialAssignment: true
        }
    },
    created () {
        this.fetchBankBranchList()
        // this.branchList = this.getBranchList()
        if (this.data) {
            const newValue = this.data
            this.beneficiary = {
                account_type: newValue.category_id,
                bank_id: newValue.category_id === 1 ? newValue.bank_id : '',
                branch_id: newValue.category_id === 1 ? newValue.branch_id : '',
                branch_district_id: newValue.category_id === 1 ? newValue.branch_district_id : '',
                bank_name: newValue.category_id === 1 ? newValue.bank_name : '',
                bank_name_bn: newValue.category_id === 1 ? newValue.bank_name_bn : '',
                branch_name: newValue.category_id === 1 ? newValue.branch_name : '',
                branch_name_bn: newValue.category_id === 1 ? newValue.branch_name_bn : '',
                bank_account_type: newValue.category_id === 1 ? newValue.account_type_id : '',
                account_name: newValue.category_id === 1 ? newValue.account_name : '',
                account_name_bn: newValue.category_id === 1 ? newValue.account_name_bn : '',
                account_no: newValue.category_id === 1 ? newValue.account_no : '',
                mfs_service: newValue.category_id === 2 ? newValue.mfs_service_id : '',
                mfs_account_name: newValue.category_id === 2 ? newValue.account_name : '',
                mfs_account_name_bn: newValue.category_id === 2 ? newValue.account_name_bn : '',
                mfs_account_no: newValue.category_id === 2 ? newValue.account_no : ''
            }
            this.dataReturn()
        }
    },
    computed: {
        districtList: function () {
            const listObject = this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0)
            return listObject.map((obj, index) => {
                if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
                } else {
                return { value: obj.value, text: obj.text }
                }
            })
        },
        beneficiaryAccountType: function () {
            if (this.service_name_check === 5) {
                const objectData = this.$store.state.commonObj.beneficiaryAccountType.filter(item => item.value !== 2)
                return objectData.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        this.beneficiary.account_type = 1
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        this.beneficiary.account_type = 1
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            } else if (this.service_name_check === 2) {
                const objectData = this.$store.state.commonObj.beneficiaryAccountType.filter(item => item.value !== 2)
                return objectData.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        this.beneficiary.account_type = 1
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        this.beneficiary.account_type = 1
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            } else {
                const objectData = this.$store.state.commonObj.beneficiaryAccountType
                return objectData.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            }
        },
        bankAccountType: function () {
            const objectData = this.$store.state.commonObj.bankAccountType
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        mfsService: function () {
            const objectData = this.$store.state.commonObj.mfsService
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
        'beneficiary.branch_district_id': function (newVal, oldVal) {
            this.getBranchList()
        },
        'beneficiary.bank_id': function (newVal, oldVal) {
            this.getBranchList()
        },
        'beneficiary.branch_id': function (newVal, oldVal) {
            if (this.beneficiary.branch_id > 0 && this.branchList.length) {
                const obj1 = this.bankList.find(item => item.value === parseInt(this.beneficiary.bank_id))
                const obj2 = this.branchList.find(item => item.value === parseInt(this.beneficiary.branch_id))
                this.beneficiary.bank_name = obj1 ? obj1.text_en : ''
                this.beneficiary.bank_name_bn = obj1 ? obj1.text_bn : ''
                this.beneficiary.branch_name = obj2 ? obj2.text_en : ''
                this.beneficiary.branch_name_bn = obj2 ? obj2.text_bn : ''
            }
        },
        '$i18n.locale': function (newVal) {
            this.fetchBankBranchList()
            this.getBranchList()
        }
    },
    methods: {
        async fetchBankBranchList () {
            this.bankList = await RestApi.getData(commonServiceBaseUrl + '/common/bank-list-all')
            this.bankList = this.bankList.map(obj => ({
                value: obj.value,
                text: this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en,
                text_en: obj.text_en,
                text_bn: obj.text_bn
            }))
        },
       async getBranchList () {
            if (this.beneficiary.branch_district_id > 0 && this.beneficiary.bank_id > 0) {
                const params = { district_id: this.beneficiary.branch_district_id, bank_id: this.beneficiary.bank_id }
                const path = '/common/branch-list-all'
                this.branchList = await RestApi.getData(commonServiceBaseUrl, path, params)
                this.branchList = this.branchList.map(obj => ({
                    value: obj.value,
                    text: this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en,
                    text_en: obj.text_en,
                    text_bn: obj.text_bn,
                    bank_id: obj.bank_id
                }))
            }
        },
        dataReturn () {
            this.$emit('beneficiary-data', this.beneficiary)
        },
        async onAttachmentChange7 (e) {
            const { valid } = await this.$refs.attachmentProvider.validate(e)

            if (valid && e.target.files.length) {
                // getBase64 of the file
                const reader = new FileReader()
                reader.readAsDataURL(e.target.files[0])
                reader.onload = (e) => {
                    this.beneficiary.attachment7 = e.target.result
                }
            }
        }
    }
}
</script>
